import type { OnInit } from '@angular/core';
import { Component, HostBinding, Inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import type {
  ImageField,
  RichTextField,
} from '@sitecore-jss/sitecore-jss-angular';
import { LocationService } from '@core/jss-seo';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import { EnvironmentConfig } from '@core/config-models';
import { ModalComponent, ModalBodyDirective } from '@legacy/common-ui-shared';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { TrackImpressionDirective } from '@analytics/events';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { SafePipe } from '@innogy/utils-deprecated';

import type {
  GenericLightboxCTAConfig,
  GenericLightboxTrackingConfig,
} from './generic-lightbox.model';

@Component({
  selector: 'wl-generic-lightbox',
  templateUrl: './generic-lightbox.component.html',
  styleUrls: ['./generic-lightbox.component.scss'],
  standalone: true,
  imports: [
    ModalComponent,
    AutomationIdDirective,
    TrackImpressionDirective,
    ModalBodyDirective,
    RichTextWrapperComponent,
    SafePipe,
  ],
})
export class GenericLightboxComponent implements OnInit {
  title?: string;
  url?: string;
  body?: RichTextField;
  tracking?: GenericLightboxTrackingConfig;
  imageLabel?: string;
  image?: ImageField;
  cta?: GenericLightboxCTAConfig;

  @HostBinding('class') classes = 'h-100';

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly locationService: LocationService,
    @Inject(ENVIRONMENT_CONFIG)
    private readonly environmentConfig: EnvironmentConfig
  ) {}

  ngOnInit() {
    if (!this.url?.startsWith('http')) {
      // Due to concatination of the basepath and url double slashes (//) may occure
      const url = `${this.environmentConfig.basePath}${this.url}`.replace(
        /\/\//g,
        '/'
      );

      this.url = this.locationService.origin + url;
    }
  }

  close() {
    this.activeModal.close();
  }

  onCtaClick() {
    this.cta?.onClick();
    this.activeModal.close('cta');
  }
}
